(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
(() => {
  const initialize = root => root.querySelectorAll('.md-category__video').forEach(video => {
    if (video.dataset.ready) return;
    video.dataset.ready = 'true';
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    const region = video.closest('.md-category');
    const button = region.querySelector('[data-category-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 981px)');
    const desktopVideo = video.classList.contains('md-category__desktop-video');
    const readyClass = desktopVideo ? 'md-desktop-video-ready' : 'md-video-ready';
    const active = () => desktopVideo ? desktop.matches : !(desktop.matches && region.classList.contains('md-category--desktop-design'));
    let visible = false;
    let userIntent = null;
    const updateButton = () => {
      if (!button) return;
      const playing = !video.paused && !video.ended;
      button.setAttribute('aria-label', playing ? button.dataset.pause : button.dataset.play);
      button.setAttribute('aria-pressed', String(playing));
    };
    const sync = () => {
      const wantsMotion = userIntent === true || (userIntent !== false && !reduced.matches);
      if (!active() || !wantsMotion) region.classList.remove(readyClass);
      if (active() && visible && !document.hidden && wantsMotion) {
        video.muted = true;
        const playback = video.play();
        if (playback) playback.catch(() => { region.classList.remove(readyClass); updateButton(); });
      } else video.pause();
      updateButton();
    };
    button?.addEventListener('click', () => { userIntent = video.paused; sync(); });
    video.addEventListener('playing', () => { if (active()) region.classList.add(readyClass); else video.pause(); updateButton(); });
    video.addEventListener('pause', updateButton);
    video.addEventListener('error', () => { region.classList.remove(readyClass); video.pause(); updateButton(); });
    reduced.addEventListener('change', () => { userIntent = null; sync(); });
    desktop.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: 0.1}).observe(region);
    updateButton();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = root => root.querySelectorAll('.md-campaign [data-campaign-video]').forEach(video => {
  if(video.dataset.ready) return;
  video.dataset.ready='true';
  video.defaultMuted=true; video.muted=true; video.loop=true; video.playsInline=true;
  let visible=true;
  const play=()=>{if(visible&&!document.hidden){const promise=video.play();if(promise)promise.catch(()=>{});}};
  video.addEventListener('playing',()=>video.closest('.md-campaign').classList.add('md-video-ready'));
  video.addEventListener('canplay',play);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else play();});
  window.addEventListener('pageshow',play);
  document.addEventListener('pointerdown',play,{once:true,passive:true});
  document.addEventListener('touchstart',play,{once:true,passive:true});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)play();else video.pause();},{threshold:.1}).observe(video);
  play();
 });
 initialize(document);
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
